import { styled } from '@abyss/web/tools/styled';
import { ToggleSwitch } from '@abyss/web/ui/ToggleSwitch';

export const TextContainer = styled('div', {
  color: '$primary1',
  paddingTop: '5px',
  paddingLeft: '0px',
});

export const BrowseAllTextContainer = styled('div', {
  color: '$primary1',
  paddingLeft: '0px',
});

export const ChipContainer = styled('div', {
  color: 'white',
  marginTop: '10px',
  paddingLeft: '16px',
  paddingRight: '16px',
});

export const ToggleSwitchStyled = styled(ToggleSwitch, {
  '.abyss-toggle-switch-container': {
    marginBottom: '$sm',
  },
  '.abyss-toggle-switch-label': {
    marginBottom: '$sm',
    fontSize: '$sm',
    fontWeight: '$medium',
    '& .voice-only-label-text': {
      border: '0',
      clip: 'rect(0 0 0 0)',
      height: '1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      userSelect: 'none',
      width: '1px',
    },
  },
  '.abyss-toggle-switch': {
    backgroundColor: '$gray6',
  },
  '.abyss-toggle-switch:after': {
    backgroundColor: '$white',
  },
});

export const ParagraphCont = styled('p', {
  fontSize: '14.22px',
  lineHeight: '20px',
  fontWeight: '$medium',
  color: '#373D3F',
});

export const letterBadgeStyles = {
  'abyss-badge-root': {
    width: '32px',
    height: '32px',
    marginTop: '$md',
    marginBottom: '12px',
  },
  'abyss-badge-content': {
    fontWeight: '$semibold',
    lineHeight: '16px',
    fontSize: '14.22px',
  },
};

export const linkStyles = {
  'abyss-link-root': {
    lineHeight: '20px',
    marginBottom: '12px',
    fontWeight: '$semibold',
    textAlign: 'left',
  },
};

export const discriptionStyle = {
  'abyss-text-root': {
    marginBottom: '$sm',
    fontSize: '$sm',
    fontWeight: '$medium',
  },
};

export const DisabledLink = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  lineHeight: '20px',
  marginBottom: '12px',
  fontWeight: '$semibold',
  textAlign: 'left',
  '& .abyss-text-root': {
    color: '$gray7',
  },
});

export const SearchCount = styled('span', {
  color: '$gray8',
  fontWeight: 700,
  fontSize: '$md',
  marginBottom: '$md',
});

export const HeadingDescriptionStyle = styled('p', {
  marginBottom: '$sm',
  fontSize: '18px',
  fontWeight: '400',
  lineHeight: '20px',
  color: '#4B4D4F',
});

export const clearStyles = {
  'abyss-button-root': {
    height: 'auto',
    border: '0px solid $tint3',
    width: '80px',
    backgroundColor: '$primary2',
    fontWeight: 'bold',
    color: '$info1',
    margin: '0px',
    marginTop: '$sm',
    cursor: 'pointer',
    justifyContent: 'center',
    lineHeight: '$sm',
    overflow: 'hidden',
    span: {
      color: '$uhcPrimary1 !important',
    },
    '&:hover': {
      backgroundColor: '$tint1',
    },
    '&:focus, &.active, &:hover:focus, &:focus-within': {
      backgroundColor: '$tint3',
    },
    textAlign: 'center',
  },
  'abyss-chip-text': {
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '$semibold',
  },
  'abyss-button-content-container': {
    span: {
      width: '53px',
    },
  },
};
